<template>
  <header>
    <div class="header-wrapper">
      <div class="top-header-wrapper">
        <div class="header-contact">
          <i class="contact-icon" />
          <h6>+254 711 058 000 | +254 732 158 000</h6>
        </div>
        <div v-if="is_logged_in" class="header-register-login">
          <div class="register-wrapper">
            <span class="register-icon" /><h6 @click.prevent="goToDashboard">
            {{ first_name }}
          </h6>
          </div>
          <div class="login-wrapper logout" @click="logout">
            <span class="login-icon" /><h6>Logout</h6>
          </div>
        </div>
        <div
            v-else
            class="header-register-login"
        >
          <div
              class="register-wrapper"
              @click="toggleRegister"
          >
            <span class="register-icon" /><h6>REGISTER</h6>
          </div>
          <div
              class="login-wrapper"
              @click="toggleLogin"
          >
            <span class="login-icon" /><h6>LOGIN</h6>
          </div>
        </div>
      </div>

      <div class="login-fields">
        <form @submit.prevent="loginUser">
          <div v-html="$error.handle(error)" />
          <input
              v-model="login.email"
              placeholder="Email Address"
              type="email"
          >
          <input
              v-model="login.password"
              placeholder="Password"
              type="password"
          >
          <div class="row">
            <span class="col-5">
              <button
                  name="Submit"
                  type="submit"
              >LOG IN</button>
            </span>
            <span class="col-2"><h5>OR</h5></span>
            <span class="col-5">
              <g-signin-button
                  :params="googleSignInParams"
                  @error="onSignInError"
                  @success="onSignInSuccess"
              >
                <span class="icon" /> Sign in with Google
              </g-signin-button>
            </span>
          </div>
          <p>
            Forgot Password?
            <router-link :to="{ name: 'forgot-password' }">
              Click Here
            </router-link>
          </p>
        </form>
      </div>

      <div class="register-fields">
        <form @submit.prevent="registerUser">
          <h3>FILL OUT THE DETAILS BELOW TO REGISTER</h3>
          <p>
            To generate Bid Bond, you can either sign up with your email, or register with your GMAIL
            account
          </p>
          <div
              style="color: red;"
              v-html="$error.handle(error)"
          />
          <input
              v-model="register.email"
              placeholder="Email Address"
              type="email"
          >
          <input
              v-model="register.password"
              placeholder="Password"
              type="password"
          >
          <input
              v-model="register.password_confirmation"
              placeholder="Confirm Password"
              type="password"
          >
          <div class="row">
            <span class="col-5">
              <button
                  name="Submit"
                  type="submit"
              >REGISTER</button>
            </span>
            <span class="col-2"><h5>OR</h5></span>
            <span class="col-5">
              <g-signin-button
                  :params="googleSignInParams"
                  @error="onSignInError"
                  @success="onSignInSuccess"
              >
                <span class="icon" /> Sign in with Google
              </g-signin-button>
            </span>
          </div>
        </form>
      </div>

      <div class="bottom-header-wraper bg-gray">
        <div class="header-logo">
          <router-link :to="{ name: 'home' }">
            <img
                alt="Credible Bonds"
                src="@/theme/images/logo.png"
            >
          </router-link>
        </div>

        <div class="header-navigation">
          <ul>
            <li>
              <router-link :to="{ name: 'home' }">
                Home
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'about' }">
                About
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'bidbonds.validate' }">
                Validate BidBond
              </router-link>
            </li>
          </ul>
        </div>
        <div class="bidbond-wrapper">
          <a
              class="cta-button header-drop-bid"
              @click.prevent="toggleQuote"
          > <span
              class="cta-icon"
          />
            <p>GET BID BOND QUOTE</p></a>
        </div>
      </div>

      <div class="bidbond-quote-fields">
        <quote />
      </div>
    </div>

    <div class="mobile-header-wrapper">
      <div class="visible-mobile-navigation">
        <div class="mobile-logo">
          <a href="/"><img src="@/theme/images/logo-dark.png"></a>
        </div>
        <input
            id="toggle"
            type="checkbox"
        >
        <label for="toggle">
          <i
              id="bars"
              class="mobile-menu-icon fa fa-bars fa-fw"
              @click="toggleMobile"
          />
          <i
              id="cross"
              class="mobile-menu-icon fa fa-times fa-fw"
              @click="toggleMobile"
          />
        </label>
      </div>
      <ul class="mobile-menu">
        <li>
          <router-link
              :to="{ name: 'home' }"
              class="active-mobile-link"
          >
            Home
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'about' }">
            About
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'bidbonds.validate' }">
            Validate BidBond
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'register' }">
            Register
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'login' }">
            Sign In
          </router-link>
        </li>

        <div class="mobile-bidbond-wrapper">
          <template v-if="isMobile">
            <router-link
                :to="{ name: 'quote' }"
                class="cta-button"
            >
              <span class="cta-icon" />
              <p>GET BID BOND QUOTE</p>
            </router-link>
          </template>
          <template v-else>
            <a
                class="cta-button"
                href="#bidbond"
            > <span class="cta-icon" />
              <p>GET BID BOND QUOTE</p></a>
          </template>
        </div>

        <div class="mobile-contact">
          <span class="contact-icon" /><h6>+254 711 041 030 | 020 2888030</h6>
        </div>

        <div class="header-social mobile_social">
          <ul>
            <li>
              <a
                  class="fa fa-twitter"
                  href="https://twitter.com/SidianBank"
                  target="_blank"
              />
            </li>
            <li>
              <a
                  class="fa fa-facebook"
                  href="https://web.facebook.com/SidianBank/"
                  target="_blank"
              />
            </li>
            <li>
              <a
                  class="fa fa-linkedin"
                  href="https://www.linkedin.com/in/sidian-bank-limited-b9510a101/"
                  target="_blank"
              />
            </li>
            <li>
              <a
                  class="fa fa-instagram"
                  href=" https://www.instagram.com/sidianbank/"
                  target="_blank"
              />
            </li>
          </ul>
        </div>
      </ul>
    </div>
  </header>
</template>

<script>
import "@/guest";
import GSignInButton from 'vue-google-signin-button'
import Vue from 'vue';
import $ from 'jquery';

window.Vue = Vue;
Vue.use(GSignInButton);

import Quote from "@/components/Guest/Quote.vue";

export default {
  components: {
    Quote
  },
  data() {
    return {
      register: {
        email: '',
        password: '',
        password_confirmation: ''
      },
      email: '',
      login: {
        email: '',
        password: ''
      },
      error: '',
      googleSignInParams: {
        client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID
      }
    }
  },
  computed: {
    first_name() {
      let name = this.loggeduser.firstname;
      if (name != null) {
        return name;
      }
      return 'User';
    },

    is_logged_in() {
      return !!this.loggeduser.email;

    },
    loggeduser() {
      return this.$store.getters.getAuthUser;
    },
  },
  methods: {
    isMobile() {
      return screen.width < 760;
    },
    toggleRegister() {
      $(".register-fields").slideToggle();
      $(".login-fields").slideUp();
      $(".bidbond-quote-fields").slideUp();
    },

    toggleLogin() {
      $(".login-fields").slideToggle();
      $(".register-fields").slideUp();
      $(".bidbond-quote-fields").slideUp();
    },

    toggleQuote() {
      $(".bidbond-quote-fields").slideToggle();
      $(".register-fields").slideUp();
      $(".login-fields").slideUp();
    },

    toggleMobile() {
      $(".mobile-menu").slideToggle();
    },

    googleSignIn() {
      $('.g-signin-button').click();
    },

    onSignInSuccess(googleUser) {
      const profile = googleUser.getBasicProfile();
      this.email = profile.getEmail();
      let auth = googleUser.getAuthResponse(true);
      this.access_token = auth.access_token;
      this.googleLogin();
    },
    onSignInError() {
      this.gtag_report_conversion()
      this.error = {status: 401, data: {message: 'Google sign in failed'}};
    },
    googleLogin() {
      let self = this;
      this.$axios.post("api/v1/auth/google", {
        access_token: self.access_token
      }).then(response => {
        this.navigateLogin(response.data);
      }).catch(err => {
        this.error = {status: 401, data: {message: err.response.data}};
      });
    },
    navigateLogin(data) {
      this.$auth.setToken(data.access_token);
      this.$axios.defaults.headers.Authorization = 'Bearer ' + this.$auth.getToken();
      this.$store.dispatch('setAuthUser', data).then(() => {
        if (this.loggeduser.requires_password_change) {
          this.$router.replace({name: 'set-password'});
          return;
        }

        if (this.loggeduser.id_number == null && !this.loggeduser.create_by_admin) {
          this.$router.replace({name: 'verify.personal'});
          return;
        }

        if (!this.loggeduser.verified_phone && this.loggeduser.id_number !== null) {
          this.$router.replace({name: 'verify.phone'});
          return;
        }

        if (this.loggeduser.verified_phone) {
          this.$router.replace({name: 'dashboard'});
        }
      });
    },
    logout() {
      this.$axios.post('/api/v1/logout').then().finally(() => {
        this.$auth.logout();
        window.location.href = this.$router.resolve({name: 'home'}).href;
      });
    },
    registerUser() {
      this.$axios.post('/api/v1/register', this.register).then(() => {
        this.$auth.setVerifyUser(this.register.email);
        window.location.href = this.$router.resolve({name: 'register.confirm'}).href;
      }).catch(error => {
        this.error = error.response;
      });
    },

    loginUser() {
      this.$axios.post('/api/v1/login', this.login).then(response => {
        this.navigateLogin(response.data);
      }).catch(err => {
        this.error = {status: 401, data: {message: 'Invalid Credentials'}};
        if (err.response.status === 403) {
          this.error = {status: 401, data: {message: err.response.data}};
        }
      });
    },
    goToDashboard() {
      this.$router.replace({name: 'dashboard'});
    }
  }
}
//    If you decide to remove the initialize on load
</script>
<style lang="scss">
.g-signin-button {
  border-radius: 5px;
  border: thin solid #888;
  box-shadow: 1px 1px 1px grey;
  display: inline-block;
  background: white;
  color: #444;
  white-space: nowrap;
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: bold;
  padding: 8px 14px 8px 8px;

  &:hover {
    cursor: pointer;
  }

  span.icon {
    background: url('/img/g-logo.png') transparent 5px 50% no-repeat;
    background-size: contain;
    display: inline-block;
    vertical-align: middle;
    width: 28px;
    height: 24px;
    margin-right: 24px;
  }
}

.row span {
  display: inline-table;
}

.col-5 {
  width: 45%
}

.col-2 {
  width: 10%
}
</style>
